// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__iu39C","content":"styles_content__3SxQa"};